 /*
 * Service: 승인잔액 조회 서비스
 * Author: KimHyunSoo
 * Date: 2021-04-26
 */

 import GentleWidget from '../common/widget';
 import GentleUtil from '../common/util';
 import GentleLang from '../common/lang';
 import GentleComponentButton from '../component/button';
 import GentleComponentBubble from '../component/bubble';
 import GentleComponentQuickReply from '../component/quickReply';
import GentleAppState from '../common/appstate';
import language from '../lang';
import template from '../template/marketingPlan';
import GentleServiceIntro from './intro';
import GentleServiceInviteMember from './inviteMember';
import GentleServiceMarketingPlan from './marketingPlan';
import GentleServiceProfile from './profile';
 
 var GentleServiceTip = Object.create( GentleWidget,{
     sponserId:{ writable: true, configurable: false, enumerable: true},
     sponserName: { writable: true, configurable: false, enumerable: true}
 })

 const inserBubble = function () {
     const {custName} = GentleAppState;
     const lang = GentleAppState.lang.toUpperCase();
     
         const string = {
             tomy: {
                 kr: {
                     ViewTips: '{name}님의 비서로서 저를 더 잘 활용하실 수 있는 방법을 준비해보았습니다. '
                 },
                 eng: {
                     ViewTips: "As {name} secretary, I have prepared a way to make better use of you."
                 }
             },
             papa: {
                 kr: {
                     ViewTips: '아직 익숙하지 않아도 괜찮아요^^ 나와 어떤 대화를 할 수 있는지, 애터미는 어떤 시스템을 갖추고 있는지 상세하게 알려줄게요. 언제든 다시 물어봐도 좋고요!'
                 },
                 eng: {
                     ViewTips: "It's okay if you're not used to it yet ^^ I'll tell you in detail what kind of conversations you can have with me, and what system Atomy has in place. Feel free to ask again at any time!"
                 }
             },
             noLogin: {
                 kr: {
                     ViewTips: '아직은 좀 생소하죠? 아래 버튼을 누르면 저와 어떻게 대화하면 좋은지, 애터미는 어떤 시스템을 갖추고 있는지 자세히 알려드릴게요.'
                 },
                 eng: {
                     ViewTips: "Still a bit unfamiliar, isn't it? If you click the button below, I will tell you in detail how to talk to me and what system Atomy has in place."
                 }
             }
         }
        
     
     

     // 봇버블
     let html;
     const persona = GentleAppState.persona;
     if (!GentleAppState.isLogin) {
         html = lang === GentleLang.lang.KR ?
             string.noLogin.kr.ViewTips :
             string.noLogin.eng.ViewTips;
     } else {
         if (persona === GentleLang.persona.TOMMY) {
             html = lang === GentleLang.lang.KR ?
                 string.tomy.kr.ViewTips :
                 string.tomy.eng.ViewTips;
         } else {
             html = lang === GentleLang.lang.KR ?
                 string.papa.kr.ViewTips :
                 string.papa.eng.ViewTips;
         }
     }

     html = html.GentleFormat({name: custName});
     
     const bubble = Object.create(GentleComponentBubble);
     bubble.createComponent({
         "html": html,
     });
     bubble.insert();
 }
 
GentleServiceTip.whatdo = function(){
    const lang = GentleAppState.lang.toUpperCase();

    inserBubble();

    {
        const component =  Object.create(this);
        const buttonTitle = lang === GentleLang.lang.KR ? '토미 사용법 보기' : 'See how to use TOMY';
        const TomyDo = lang === GentleLang.lang.KR ? '토미는 어떤 일을 하나요?' : 'What does TOMY do?';
        const html = `
        <div class="card-view">
            <div class="banner-container">
                <h3>${TomyDo}</h3>
                <figure class="gentle-banner">
                    <img src = "/assets/images/banner/${lang === GentleLang.lang.KR ? 'b1.svg': 'b1_en.png'}">
                </figure>
                <div class="gentle-button-group">
                    <div class="wide-button">
                        <button type="button" class="primary default">${buttonTitle}</button>
                    </div>
                </div>
            </div>
        </div>`;
        const $card = $(html);
        $card.find('button').bind('click', 
        function(){
            console.log('챗봇 도움말 보기')
            GentleComponentBubble.insertUserBubble({html: buttonTitle, send:false});
            GentleServiceIntro.introInit({
                intro : {
                    startScene: 'scene-common-1', 
                    skipAppLoading:true, 
                    ignoreCookie:true
                }
            });
        });
        component.insertElement($card);
    };
}

GentleServiceTip.invite = function(){
    const lang = GentleAppState.lang.toUpperCase();
    const {custName} = GentleAppState;

    inserBubble();

    {
        const component =  Object.create(this);
        const buttonTitle = lang === GentleLang.lang.KR ? '회원초대 바로 하기' : 'Member Invite Now';

        const html = `
        <div class="card-view">
            <div class="banner-container">
                <h3>${lang === GentleLang.lang.KR ? '회원초대, 어떻게 하죠?' : 'How do I invite a member?'}</h3>
                <figure class="gentle-banner">
                    <img src = "/assets/images/banner/${lang === GentleLang.lang.KR ? 'b2.svg': 'b2_en.png'}">
                </figure>
                <div class="gentle-button-group">
                    <div class="wide-button">
                        <button type="button" class="primary default">
                        ${buttonTitle}
                        </button>
                    </div>
                </div>
            </div>
        </div>`;
        const $card = $(html);
        $card.find('button').bind('click', 
        function(){
            console.log('회원초대 쉽게 하기 ')
            GentleComponentBubble.insertUserBubble({html: buttonTitle, send: false});
            GentleServiceInviteMember.main();
        });
        component.insertElement($card);
        };
}

GentleServiceTip.plan = function(){
    const lang = GentleAppState.lang.toUpperCase();
    const {custName} = GentleAppState;

    inserBubble();

    {
        const component =  Object.create(this);

        const buttonTitle = lang === GentleLang.lang.KR ? '마케팅 플랜 알아보기' : 'Learn about our marketing plan';
        const html = `
        <div class="card-view">
            <div class="banner-container">
                <h3>${lang === GentleLang.lang.KR ? '마케팅 플랜, 그게 뭐죠?' : 'Marketing plan, what is it?'}</h3>
                <figure class="gentle-banner">
                    <img src = "/assets/images/banner/${lang === GentleLang.lang.KR ? 'b3.png': 'b3_en.png'}">
                </figure>
                <div class="gentle-button-group">
                    <div class="wide-button">
                        <button type="button" class="primary default">
                        ${buttonTitle}
                        </button>
                    </div>
                </div>
            </div>
        </div>`;
        const $card = $(html);
        $card.find('button').bind('click', 
        function(){
            console.log('마켓팅 플랜 알아보기')
            GentleComponentBubble.insertUserBubble({html: buttonTitle});
            GentleServiceMarketingPlan.main();
        });
        component.insertElement($card);
    };
}

GentleServiceTip.profile = function(){
    const lang = GentleAppState.lang.toUpperCase();
    const {custName} = GentleAppState;

    inserBubble();

    {
        const component =  Object.create(this);

        const buttonTitle = lang === GentleLang.lang.KR ? '프로필 이미지 변경하기' : 'Change your profile image';
        const html = `기
        <div class="card-view">
            <div class="banner-container">
                <h3>${lang === GentleLang.lang.KR ? '나의 프로필 이미지, 바꾸고 싶다면?' : 'What if I want to change my profile image?'}</h3>
                <figure class="gentle-banner">
                    <img src = "/assets/images/banner/${lang === GentleLang.lang.KR ? 'b4.png': 'b4_en.png'}">
                </figure>
                <div class="gentle-button-group">
                    <div class="wide-button">
                        <button type="button" class="primary default">
                        ${buttonTitle}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        `;
        const $card = $(html);
        $card.find('button').bind('click', 
        function(){
            console.log('프로필 수정하기')
            GentleComponentBubble.insertUserBubble({html: buttonTitle});
            GentleServiceProfile.main();
        });
        component.insertElement($card);
    };
}
 
 export default GentleServiceTip;